module.exports = __webpack_public_path__ + "img/ps.22be50de.svg";